"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _lodash = _interopRequireDefault(require("lodash.isequal"));

require("./styles/autosave.scss");

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var Autosave = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.callFunction = function () {
      var a = d.state.lastData,
          b = d.props,
          c = b.functionToCall,
          e = b.data,
          f = !(0, _lodash["default"])(e, a);
      f && (d.setState({
        loadingState: "loading"
      }), setTimeout(function () {
        return d.setState({
          loadingState: "disappear"
        });
      }, 600), setTimeout(function () {
        return d.setState({
          loadingState: ""
        });
      }, 900), d.setState({
        lastData: e
      }), c(e));
    }, d.state = {
      loadingState: "",
      lastData: a.data
    }, d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var a = this.props.secondsBetweenSaves,
          b = setInterval(this.callFunction, 1e3 * a);
      this.setState({
        loopInterval: b
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var a = this.state.loopInterval;
      clearInterval(a);
    }
  }, {
    key: "render",
    value: function render() {
      var a = this.state.loadingState;
      return _react["default"].createElement("div", {
        className: "autosave__loading",
        style: {
          width: "disappear" === a ? "0%" : "100%"
        }
      }, _react["default"].createElement("div", {
        className: "autosave__loading__bar",
        style: {
          width: "loading" === a ? "100%" : "0%"
        }
      }));
    }
  }]), b;
}(_react.Component);

exports["default"] = Autosave, Autosave.defaultProps = {
  secondsBetweenSaves: 10
};